/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Custom serializer for password reset view.
 * @export
 * @interface PasswordResetRequest
 */
export interface PasswordResetRequest {
    /**
     * 
     * @type {string}
     * @memberof PasswordResetRequest
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof PasswordResetRequest
     */
    resetToken?: string;
    /**
     * 
     * @type {string}
     * @memberof PasswordResetRequest
     */
    newPassword?: string;
}

/**
 * Check if a given object implements the PasswordResetRequest interface.
 */
export function instanceOfPasswordResetRequest(value: object): value is PasswordResetRequest {
    return true;
}

export function PasswordResetRequestFromJSON(json: any): PasswordResetRequest {
    return PasswordResetRequestFromJSONTyped(json, false);
}

export function PasswordResetRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordResetRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
        'resetToken': json['reset_token'] == null ? undefined : json['reset_token'],
        'newPassword': json['new_password'] == null ? undefined : json['new_password'],
    };
}

export function PasswordResetRequestToJSON(json: any): PasswordResetRequest {
    return PasswordResetRequestToJSONTyped(json, false);
}

export function PasswordResetRequestToJSONTyped(value?: PasswordResetRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'reset_token': value['resetToken'],
        'new_password': value['newPassword'],
    };
}

